"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for when a class field failed validation
 * @param {string} field the field that failed validation
 * @param {string} message the validation message
 */
class ClassBodyNotValidError extends client_library_1.ExtendableError {
    constructor(field, message) {
        super(`class: ${field} failed validation. ${message}`);
        this.field = field;
    }
}
exports.default = ClassBodyNotValidError;
//# sourceMappingURL=ClassBodyNotValidError.js.map